import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white monthly-revenue-box radius-7 heigth-other-cards-dashboard" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing radius-7 total-time-card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis font-cards-dashboard" }, "Tempo total de gravação", -1)
const _hoisted_4 = { class: "fw-black mb-12 lh-1 font-size-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.convertTime(_ctx.getDashboardDayCards.total_time)), 1)
    ])
  ]))
}